import arrowDown from './icons/arrow-down.svg';
import arrowLeft from './icons/arrow-left.svg';
import arrowRight from './icons/arrow-right.svg';
import arrowUp from './icons/arrow-up.svg';
import cart from './icons/cart.svg';
import check from './icons/check.png';
import checkCircled from './icons/check-circled.svg';
import chevronDown from './icons/chevron-down.svg';
import chevronLeft from './icons/chevron-left.svg';
import chevronRight from './icons/chevron-right.svg';
import chevronUp from './icons/chevron-up.svg';
import close from './icons/close.svg';
import distribution from './icons/distribution.svg';
import downloadDocument from './icons/download-document.svg';
import email from './icons/email.svg';
import exclamationMarkCircled from './icons/exclamation-mark-circled.svg';
import externalLink from './icons/external-link.svg';
import facebook from './icons/facebook.svg';
import globe from './icons/globe.svg';
import hamburger from './icons/hamburger.svg';
import infoCircle from './icons/info-circle.svg';
import instagram from './icons/instagram.svg';
import linkedin from './icons/linkedin.svg';
import location from './icons/location.svg';
import manufacturing from './icons/manufacturing.svg';
import minus from './icons/minus.svg';
import phone from './icons/phone.svg';
import plus from './icons/plus.svg';
import questionMarkCircled from './icons/question-mark-circled.svg';
import quote from './icons/quote.svg';
import sales from './icons/sales.svg';
import scroll from './icons/scroll.svg';
import search from './icons/search.svg';
import triangleDown from './icons/triangle-down.svg';
import twitter from './icons/twitter.svg';
import waffle from './icons/waffle.svg';
import youtube from './icons/youtube.svg';
import wrench from './icons/wrench.svg';
import unicorn from './icons/unicorn.svg';
import singleMan from './icons/single-man.svg';
import singleManQuestion from './icons/single-man-question.svg';

function png(icon: string): string {
    return `<img src="${icon}" alt="" aria-hidden="true" />`;
}

export const icons: { [name: string]: string } = {
    arrowDown,
    arrowLeft,
    arrowRight,
    arrowUp,
    cart,
    check: png(check),
    checkCircled,
    chevronDown,
    chevronLeft,
    chevronRight,
    chevronUp,
    close,
    distribution,
    downloadDocument,
    dropdown: chevronDown,
    email,
    exclamationMarkCircled,
    externalLink,
    facebook,
    globe,
    hamburger,
    infoCircle,
    instagram,
    linkedin,
    location,
    manufacturing,
    minus,
    phone,
    plus,
    questionMarkCircled,
    quote,
    sales,
    scroll,
    search,
    triangleDown,
    twitter,
    waffle,
    youtube,
    singleMan,
    singleManQuestion,
    wrench,
    unicorn,
};

function capitalize(str: string): string {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
}

export function getIcon(name?: string): string {
    if (!name) return '';
    const [first, ...rest] = name.split('-');
    const iconName = first + rest.map(capitalize).join('');
    return icons[iconName] || '';
}
